import axios from 'axios';
import { VITE_API_BASE_URL } from '@/config';

export default class BaseApi {
  constructor(basePath = '') {
    this.api = axios.create({
      baseURL: `${VITE_API_BASE_URL}${basePath}`,
    });

    this.api.interceptors.request.use(async config => {
      // Resolve auth after module initialization: AuthService itself extends BaseApi.
      if (!config.skipToken) {
        const { default: user } = await import('@/services/Auth/authInstance');
        const token = user.getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    });

    this.api.interceptors.response.use(
      (resp) => resp,
      async (error) => {
        const status = error?.response?.status;
        if (status === 401) {
          // токен невалиден → сразу чистим сессию,
          // чтобы UI перестал думать, что юзер залогинен
          try {
            const { default: user } = await import('@/services/Auth/authInstance');
            user.logout();
          } catch {}
        }
        return Promise.reject(error);
      }
    );
  }

}
